import type { SVGProps } from "react";
// generated from MessagePlus.svg — do not edit manually
// prettier-ignore
export default function MessagePlus(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 8 11 H 16 M 12 7 V 15 M 3 3 H 21 V 19 H 12 L 7 22 V 19 H 3 V 3 Z" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
